import { isWithinInterval } from '@/utils/date-fns';
import i18n from '@/utils/i18n';

const iconMap = {
  morgen: 'sunrise',
  eftermiddag: 'sun',
  aften: 'sunset',
  nat: 'moon-stars',
};

export function getSimpleTime(departmentSettings) {
  const currentActiveInterval = departmentSettings.simpleSchedulePlan.find(
    (interval) => {
      isWithinInterval(interval.starttime, interval.endtime);
    }
  );

  return {
    ...currentActiveInterval,
    icon: currentActiveInterval?.icon
      ? iconMap[currentActiveInterval?.icon]
      : iconMap.eftermiddag,
    name: currentActiveInterval?.name
      ? currentActiveInterval?.icon
      : i18n.global.t('global.today'),
  };
}
